import jsPDF from "jspdf";
const CertificateVer = ({ x, y, imagePath }) => {
  var lMargin = 10; //left margin in mm
  var rMargin = 10; //right margin in mm
  var pdfInMM = 550;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "px",
    format: [1122.52, 793.71],
  });

  var imagebase64 = "";

  async function encodeImageFileAsURL() {
    var file = await imagePath;
    var reader = new FileReader();
    reader.onloadend = function () {
      imagebase64 = reader.result;
    };
    reader.readAsDataURL(file);
  }

  const genCertificate = async () => {
    console.log(y);
    await encodeImageFileAsURL();

    try {
      doc.addImage(imagebase64, "PNG", 0, 0, 1122.5, 793.71);
      doc.setFontSize(24);
      doc.setTextColor(38, 36, 37);
      doc.setFont("Helvetica", "normal");
      var lines = doc.splitTextToSize(
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Saepequaerat nesciunt consectetur reiciendis perferendis consequunturaspernatur aliquid animi omnis blanditiis?",
        pdfInMM - lMargin - rMargin
      );
      doc.text(x.xContent, y.yContent + 20, lines);

      doc.setFontSize(40);
      doc.setFont("times", "italic");
      doc.text("Aniket Singh", x.xName, y.yName + 20);

      doc.setFontSize(17);
      doc.setFont("Helvetica");
      doc.text("04/10/2021", x.xDate, y.yDate + 11);

      // doc.setFontSize(20);
      // doc.text("Of Participation", x.xTypeCode, y.yTypeCode + 20);

      doc.setFontSize(17);
      doc.setFont("Helvetica");
      doc.text("12hyhhjfj12355", x.xCid, y.yCid + 11);

      doc.setFontSize(17);
      doc.setFont("Helvetica");
      doc.text(
        "https://verifymycertificates.web.app/",
        x.xVerificationUrl,
        y.yVerificationUrl + 16
      );

      doc.setFontSize(25);
      doc.setFont("times", "italic");
      doc.text("Roshan Paturkar", x.xLeadName, y.yLeadName + 20);

      doc.save("a4.pdf");
    } catch (error) {
      alert("plaease press the button onece again");
      console.log(error);
    }
  };

  return (
    <div className="pageCerti">
      <button
        onClick={() => {
          genCertificate();
        }}
      >
        Preview
      </button>
    </div>
  );
};

export default CertificateVer;
